'use client';

export type UserRole = 'customer' | 'business' | null;

export interface SessionUser {
  role: UserRole;
  name?: string;
  email?: string;
  pinCode?: string;
  businessName?: string;
}

export interface StoredOffer {
  id: string;
  businessName: string;
  businessPinCode: string;
  title: string;
  description: string;
  discountType: string;
  discountValue: string;
  startDate: string;
  endDate: string;
  maxRedemptions: string;
  termsConditions: string;
  visibility: string;
  photoUrl: string | null;
  createdAt: string;
  status: 'published' | 'draft';
}

const SESSION_KEY = 'ofy_session';
const OFFERS_KEY = 'ofy_offers';

export function getSession(): SessionUser | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}

export function setSession(user: SessionUser): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(SESSION_KEY, JSON.stringify(user));
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(SESSION_KEY);
}

export function isLoggedIn(): boolean {
  return getSession() !== null;
}

export function saveOffer(offer: StoredOffer): void {
  if (typeof window === 'undefined') return;
  try {
    const existing = getOffers();
    existing.push(offer);
    localStorage.setItem(OFFERS_KEY, JSON.stringify(existing));
  } catch {
    // ignore
  }
}

export function getOffers(): StoredOffer[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(OFFERS_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as StoredOffer[];
  } catch {
    return [];
  }
}

export function getOffersByPinCode(pinCode: string): StoredOffer[] {
  return getOffers().filter(
    (o) => o.businessPinCode === pinCode && o.status === 'published' && o.visibility !== 'draft'
  );
}
